import { render, staticRenderFns } from "./app-menu-item.vue?vue&type=template&id=42f0ef23&scoped=true&"
import script from "./app-menu-item.vue?vue&type=script&lang=ts&"
export * from "./app-menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./app-menu-item.vue?vue&type=style&index=0&id=42f0ef23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0ef23",
  null
  
)

export default component.exports